import React from 'react';
import QuestionCircle from "../../assets/images/icons/question-circle.svg";

const ConfirmModal = ({
						  text = 'Вы действительно хотите удалить?',
						  isSubmitting = false,
						  onConfirmHandler = () => {
						  },
						  onCancelHandler = () => {
						  },
						  children
					  }) => {
	return (
		<div className="modal-body">
			<div className='!flex !items-start'>
				<img src={QuestionCircle} alt="" width={25} height={25} className='mr-15'/>
				<div>
					{children}
					<div className='fw-600 lh-24 mb-30'>
						{text}
					</div>
				</div>
			</div>
			<div className='!flex !justify-end'>
				<button onClick={onCancelHandler} className={'d-btn d-btn-default d-btn--small mr-10'}>нет</button>
				<button onClick={onConfirmHandler}
						className={`d-btn d-btn-danger d-btn--small ${isSubmitting ? '--loading' : ''}`}>да
				</button>
			</div>
		</div>
	);
};

export default ConfirmModal;
